import { Pipe, PipeTransform } from '@angular/core';
import { langTag } from 'src/app/shared/function';

@Pipe({
	name: 'langTag',
	standalone: true,
})
export class LangTagPipe implements PipeTransform {
	// Used to get translated text from object by tag, retrun tag itself if it missing in object
	transform(value: Record<string, string> | null, ...args: string[]): string {
		const textTransform = args[1] ?? '';

		if (value === null) return args[0];

		let text = langTag(value, args[0]);

		switch (textTransform) {
			case 'uppercase':
				return text.toUpperCase();
			case 'lowercase':
				return text.toLowerCase();
			case 'capitalize':
				text = text.slice(0, 1).toUpperCase() + text.slice(1);
				return text;

			default:
				return text;
		}
	}
}
